class CustomTabs extends HTMLElement {
  constructor() {
    super();
    let tabButtons = this.querySelectorAll('[data-tab-button]');
    let tabContents = this.querySelectorAll('[data-tab-content]');
    tabButtons.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabButtons.forEach(function (btn) {
          btn.classList.remove('collection__tabs-button--active');
        });
        tab.classList.add('collection__tabs-button--active');
        let tabBtnTitle = tab.getAttribute('data-tab-button');
        tabContents.forEach(function (content) {
          content.classList.remove('collection__tabs-item--active');
        });
        tabContents.forEach(function (content) {
          let tabContentTitle = content.getAttribute('data-tab-content');
          if (tabContentTitle === tabBtnTitle) {
            content.classList.add('collection__tabs-item--active');
          }
        });
      });
    });
  }
}
customElements.define('custom-tabs', CustomTabs);
